<template>


  <b-row align-h="center" align="center" :key="componentKey">
    <b-col xs="12" sm="12" md="6" lg="3" xl="3">

      <b-tabs>
        <p></p>
<!--
        <b-tab title="Cargar Lote">

          <b-row>
            <b-col>
              <b-form-file v-model="archivoLote" :state="Boolean(archivoLote)" placeholder="Seleccione el archivo"
                @change="LoteBase64"></b-form-file>
            </b-col>
          </b-row>

          <p></p>

          <b-row>
            <b-col>
              <b-link @click="descargaPlantilla">Descargar plantilla</b-link>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-input @input="filtroCaracteresEspeciales" class="text-center" v-model="nombreLote"
                placeholder="Nombre del lote" :state="validacionNombreLote"></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-check v-model="checkAplicarLote" value=true unchecked-value=false>Aplicar</b-check>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <p></p>
              <b-button pill variant="success" size="lg" @click="cargarLote()">Cargar
                Lote</b-button>
              <p></p>
            </b-col>
          </b-row>

          <b-row v-if="banderaSpinnerCargaLote == 1">
            <b-col>
              <b-spinner label="Espere un momento, por favor..."></b-spinner>
            </b-col>
          </b-row>

          <b-row v-if="banderaCargaExitosa == 1">
            <b-col>
              <b-alert show variant="warning">SE HA CARGADO EL LOTE DE FORMA EXITOSA</b-alert>
            </b-col>
          </b-row>


        </b-tab>

-->

<!--
        <b-tab title="Consultar Lote">
-->
          <!--
          <b-row align-h="left" align="left">
            <b-col>
              <span ><strong>Seleccione el archivo:</strong></span>
            </b-col>
          </b-row>
          -->
<!--
          <b-row>
            <b-col>
              <h5>Descargar lote:</h5>
            </b-col>
          </b-row>

          <b-row align-h="left" align="left">
            <b-col>
              <span>Fecha de incio:</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col style="cursor: pointer;">
              <b-form-datepicker v-model="fechaInicioLote"></b-form-datepicker>
            </b-col>
          </b-row>

          <p></p>

          <b-row align-h="left" align="left">
            <b-col>
              <span>Fecha de final:</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col style="cursor: pointer;">
              <b-form-datepicker v-model="fechaFinalLote"></b-form-datepicker>
            </b-col>
          </b-row>

          <p></p>

          <b-row align-h="center" align="center">
            <b-col>
              <b-button pill variant="success" @click="consultarLotes">Consultar lotes</b-button>
            </b-col>
          </b-row>

          <p></p>

          <b-row v-if="banderaTablaLotes == 1">
            <b-col>
              <b-table :items="items" :fields="fields">
                <template #cell(icon)="{ item }">
                  <b-icon :icon="item.iconName" @click="loteSeleccionado(item)"></b-icon>
                </template>
              </b-table>
            </b-col>
          </b-row>

        </b-tab>
-->
      </b-tabs>



    </b-col>
  </b-row>

</template>

<script>
import axios from "axios";
import FileSaver from 'file-saver';

export default {


  computed: {

    validacionNombreLote() {
      return this.nombreLote == '' ? false : true
    },

    token: {
      get: function () {
        return this.$store.state.user.token;
      },
      set: function (newIsWorking) {
        this.$store.commit("updateToken", newIsWorking);
      }
    }
  },


  data() {
    return {
      //variables

      cliente: "",
      //url: "http://192.168.0.100:8080/",
      //url: "https://optimal-central-pug.ngrok-free.app/",
      url: "https://tphavawsqa.a.pinggy.link/",

      archivoLote: null,
      banderaDescargaLote: 0,
      loteExcel: '',
      lotes: '',
      banderaSpinnerCargaLote: 0,
      banderaCargaExitosa: 0,
      banderaCargaNuevoLote: 0,
      archivoLoteBase64: null,
      nombreLote: '',
      checkAplicarLote: false,


      banderaTablaLotes: 0,


      fechaInicioLote: '',
      fechaFinalLote: '',
      fields: [
        { key: 'lote', label: 'Lote' },
        { key: 'icon', label: '' }
      ],

      items: [],

      valorItem: '',
      componentKey: 0,
      lotesRecibidos: ''

    };
  },

  created: function () {

    const queryString = window.location.href;

    const url = new URL(queryString);

    const cliente = url.pathname.split('/')[1];

    this.cliente = cliente

    axios({
      method: 'post',
      url: this.url + 'catalogosum',
      params: { "codeClient": this.cliente },
      data: null,
      headers: {
        'Authorization': this.token,

      }
    })
      .then((res) => {
        this.departamentos = res.data.departamentos

        this.proveedores = res.data.proveedores

      }).catch(err => {

        if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

          alert('Servicio no disponible, intente de nuevo más tarde');

        }

        else if (err.response.status == 500) {

          alert('Error en la red, verifique su conexión a internet 2');
        }

        else {

          alert(err);

        }
      });

  },



  methods: {

    LoteBase64(evt) {

      this.banderaCargaExitosa = 0

      if (evt.target.files.length > 0) {
        this.LoteBase64_2(evt.target.files[0]);
      }
    },

    LoteBase64_2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.loteExcel = base64String;
        };

      })(f);


      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);

    },

    filtroCaracteresEspeciales() {
      this.nombreLote = this.nombreLote.replace(/[^a-zA-Z0-9\s]/g, '');
    },

    cargarLote() {

      this.banderaSpinnerCargaLote = 1

      this.nombreLote = this.nombreLote.replace(/[^a-zA-Z0-9\s]/g, '');

      axios({
        method: 'post',
        url: this.url + 'generalote',

        data: {
          "nombre": this.nombreLote,
          "xlsx": this.loteExcel,
          "aplicar": this.checkAplicarLote

        },
        headers: {
          'Authorization': this.token,

        }
      })
        .then(() => {

          this.banderaCargaExitosa = 1
          this.banderaSpinnerCargaLote = 0
          this.banderaCargaNuevoLote = 0
          this.nombreLote = ''
          this.archivoLote = null
          this.checkAplicarLote = false
          this.componentKey += 1;

        }).catch(err => {


          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

            this.banderaCargaExitosa = 0
            this.banderaSpinnerCargaLote = 0

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

            this.banderaCargaExitosa = 0
            this.banderaSpinnerCargaLote = 0

          }

          else {

            if (err.config.headers.Authorization != null) {

              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split('/')[1];
              window.location.href = '/' + cliente + '/login';
            }

            //alert(err + ' Servicio no disponible, intente de nuevo más tarde');
            //alert(err + ' Servicio no disponible, intente de nuevo más tarde');

          }
        });
    },




    descargaPlantilla() {

      axios({
        method: 'post',
        url: this.url + 'descargaplantilla',

        data: { "lote": "nombrelote" },

        headers: {
          'Authorization': this.token,

        }
      })
        .then((res) => {

          this.archivoLoteBase64 = res.data.xlsx

          var byteString = atob(this.archivoLoteBase64);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);

          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          FileSaver.saveAs(new Blob([ab], { type: "application/octet-stream" }), 'ejemplo.xlsx');
        }).catch(err => {

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');
          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');


          }

          else {

            if (err.config.headers.Authorization != null) {

              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split('/')[1];
              window.location.href = '/' + cliente + '/login';
            }

            //alert(err + ' Servicio no disponible, intente de nuevo más tarde');

          }
        });



    },

    consultarLotes() {

      this.banderaTablaLotes = 1


      axios({
        method: 'post',
        url: this.url + 'lotes',

        data: {
          "fechaInicio": this.fechaInicioLote,
          "fechaFinal": this.fechaFinalLote
        },
        headers: {
          'Authorization': this.token,

        }
      })
        .then((res) => {

          this.lotesRecibidos = res.data
          //alert(this.lotesRecibidos)

          for (var i = 0; i < this.lotesRecibidos.length; i++) {
            //alert('entra al for')
            //alert(this.lotesRecibidos[i])
            this.items.push({ lote: this.lotesRecibidos[i], iconName: 'arrow-down-circle-fill' });
            //alert(this.items)
          }

        }).catch(err => {

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {

              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split('/')[1];
              window.location.href = '/' + cliente + '/login';
            }
            alert(err);


          }

        });



      //alert(this.items)

    },


    loteSeleccionado(item) {

      alert('Lote a descargar: ' + item.lote);

      axios({
        method: 'post',
        url: this.url + 'lote',

        data: {
          "nombre": item.lote
        },
        headers: {
          'Authorization': this.token,

        }
      })
        .then(() => {


        }).catch(err => {

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }


          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');


          }

          else {

            if (err.config.headers.Authorization != null) {

              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split('/')[1];
              window.location.href = '/' + cliente + '/login';
            }
            alert(err);


          }

        });
    }

  },
};
</script>

<style>
/* BASIC */

html {
  background-color: #ffffff;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #ffffff;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/

input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #ffffff;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #ffffff;
}

input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type="text"]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.card-option {
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 15px;
  border-bottom: solid 4px rgb(68, 63, 173);
  background-color: white;
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 60%;
}
</style>
